
import { MotionValue } from 'motion/react'
import { useContext, createContext } from 'react';

export interface ScrollContextType {
  progress: MotionValue<number>;
}

export const ScrollContext = createContext<ScrollContextType | null>(null);
export const useScrollContext = () => {
  return useContext(ScrollContext);
};